import { useEffect, useState } from "react";
import { Loader2, MapPin } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";

const FIELDS = [
  ["brand", "Code enseigne", 8],
  ["sender_name", "Nom de l'expéditeur", 32],
  ["sender_address", "Adresse (n° et rue)", 32],
  ["sender_postal", "Code postal", 5],
  ["sender_city", "Ville", 26],
  ["sender_phone", "Téléphone", 16],
  ["sender_email", "E-mail (facultatif)", 70],
];

export default function MondialRelaySettingsCard() {
  const [form, setForm] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/admin/mondial-relay/settings").then(({ data }) => setForm((cur) => cur || data)).catch(() => {}); }, []);
  if (!form) return null;

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.put("/admin/mondial-relay/settings", form);
      setForm(data);
      toast.success("Réglages Mondial Relay enregistrés");
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Vérifiez les champs : code enseigne de 8 caractères, adresse, code postal à 5 chiffres, ville et téléphone sont obligatoires");
    } finally {
      setBusy(false);
    }
  };

  const input = "mt-1 w-full rounded-xl border border-amber-900/20 bg-cream px-4 py-2.5 text-sm outline-none focus:border-amber-deep";
  return (
    <form data-testid="mondial-relay-settings" onSubmit={save} className="rounded-2xl border border-amber-800/15 bg-white p-6 shadow-sm">
      <h2 className="flex items-center gap-2 font-serif text-xl font-semibold text-bark"><MapPin size={18} className="text-honey" /> Mondial Relay — expéditeur des étiquettes</h2>
      <p className="mt-1 text-sm text-bark-soft">Le mode « Point Relais Mondial Relay » se règle comme les autres modes ci-dessous (prix par tranche de poids). Ces informations figurent sur les étiquettes.</p>
      <div className="mt-4 grid gap-4 sm:grid-cols-2">
        {FIELDS.map(([k, label, max]) => (
          <label key={k} className="text-sm font-medium text-bark">{label}
            <input data-testid={`mr-setting-${k}`} value={form[k] || ""} maxLength={max} onChange={(e) => setForm({ ...form, [k]: k === "brand" ? e.target.value.toUpperCase() : e.target.value })} className={input} />
          </label>
        ))}
        <label className="text-sm font-medium text-bark">Format de l'étiquette
          <select data-testid="mr-setting-label_format" value={form.label_format} onChange={(e) => setForm({ ...form, label_format: e.target.value })} className={input}>
            <option value="10x15">10 × 15 cm (imprimante d'étiquettes)</option>
            <option value="A5">A5</option>
            <option value="A4">A4</option>
          </select>
        </label>
      </div>
      <button data-testid="mr-settings-save" disabled={busy} className="mt-4 flex items-center gap-2 rounded-full bg-amber-deep px-6 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-honey disabled:opacity-60">
        {busy && <Loader2 size={15} className="animate-spin" />} Enregistrer
      </button>
    </form>
  );
}
